import {
    notification, Spin,
    Drawer,
    Space,
    Typography,
} from 'antd';
import { FC, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getDriverById } from '../../api/drivers.api';
import { useDriversContext } from '../../components/Drivers/context/drivers.ctx';
import DriverCard from '../../components/DriverCard';
import { IDriver } from '../../interfaces/driver.interface';

const { Text } = Typography;

const Driver: FC = () => {
    const { t } = useTranslation('drivers', { keyPrefix: 'DRIVERS' });

    const { driver: driverID, setDriver: setDriverID } = useDriversContext();

    const [loading, setLoading] = useState(false);
    const [driver, setDriver] = useState<any>();

    const getDriver = () => {
        setLoading(true);
        getDriverById(driverID as string)
            .then((response) => {
                setDriver(response.data);
            })
            .catch((error: any) => {
                const description = error.response.data.message;
                notification.error({
                    message: t('DRIVER_NOT_OBTAINED'),
                    description,
                });
            })
            .finally(() => setLoading(false));
    };

    useEffect(() => {
        if (!driverID) return;
        getDriver();
    }, [driverID]);

    return (
        <Drawer
            open={!!driverID}
            width={750}
            title={`${t('DRIVER')} | ${driver?.name || ''} ${driver?.lastName || ''}`}
            style={{ padding: 0, width: '100%' }}
            onClose={() => setDriverID(null)}
        >
            {
                loading
                    ? (
                        <Space size={8}>
                            <Spin size="small" />
                            <Text>{t('LOADING')}</Text>
                        </Space>
                    ) : (
                        <DriverCard
                            driver={driver as IDriver}
                        />
                    )
            }
        </Drawer>
    );
};

export { Driver };
